import { render, staticRenderFns } from "./UploadedProduct.vue?vue&type=template&id=aa049fde&scoped=true&"
import script from "./UploadedProduct.vue?vue&type=script&lang=js&"
export * from "./UploadedProduct.vue?vue&type=script&lang=js&"
import style0 from "./UploadedProduct.vue?vue&type=style&index=0&id=aa049fde&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa049fde",
  null
  
)

export default component.exports